<template>
    <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="分成方角色：">
              <el-select style="width: 200px;" v-model="formInline.type" filterable placeholder="请选择">
                  <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="签约时长：">
            <el-input
                v-model="formInline.time"
                style="max-width: 200px"
                placeholder="请输入签约时长"
                >
                <template #append>个月</template>
            </el-input>
          </el-form-item>
          <el-form-item label="合作期限：">
            <el-date-picker
                v-model="formInline.date"
                value-format="YYYY-MM-DD"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
            />
          </el-form-item>
          <el-form-item label="关键字：">
              <el-input v-model="formInline.keyword" placeholder="请输入分成方名称或账户名或收款账号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search()">搜索</el-button>
            <el-button type="primary" @click="showAdd()">新建</el-button>
            <!-- <el-button type="primary">导出</el-button> -->
          </el-form-item>
      </el-form>
      <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="ID" width="80">
          <template #default="scope">
            <div>
              <span>{{scope.row.id}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分成方名称" width="200" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分成方角色" width="150">
          <template #default="scope">
            <div>
              <span>{{ typeFilter(scope.row.type) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="账户名" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.username || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收款账号" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.account || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="开户行" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.bankOf || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="合作期限" width="300">
          <template #default="scope">
            <div>
              <span>{{ scope.row.start || '--' }} 至 {{ scope.row.end || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="签约时长（月）" width="130">
          <template #default="scope">
            <div>
              <span>{{ scope.row.time }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="scope">
            <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
              编辑
            </el-button>
            <!-- <el-button type="success" size="small">
              查看合同
            </el-button> -->
            <el-button
              size="small"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <Pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
  
      <!-- 对话框--新建、编辑组织 -->
      <el-dialog v-model="dialogFormVisible" :title="dialogTitle" width="500" :close-on-click-modal="false" @closed="$refs.addFormRef?.clearValidate()">
          <el-form ref="addFormRef" label-position="right" label-width="auto" :model="addInfo" :rules="addRules">
          <el-form-item label="分成方名称" prop="name">
            <el-input v-model="addInfo.name" autocomplete="off" />
          </el-form-item>
          <el-form-item label="分成方角色" prop="type">
            <el-select v-model="addInfo.type" placeholder="请选择">
              <el-option
                  v-for="item in rolesList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账户名" prop="username">
            <el-input v-model="addInfo.username" autocomplete="off" />
          </el-form-item>
          <el-form-item label="收款账号" prop="account">
            <el-input v-model="addInfo.account" autocomplete="off" />
          </el-form-item>
          <el-form-item label="开户行" prop="bankOf">
            <el-input v-model="addInfo.bankOf" autocomplete="off" />
          </el-form-item>
          <el-form-item label="合作期限" prop="date"> 
            <el-date-picker
                v-model="addInfo.date"
                value-format="YYYY-MM-DD"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
            />
          </el-form-item>
          <el-form-item label="合作时长" prop="time">
              <el-input v-model="addInfo.time" autocomplete="off">
                <template #append>个月</template>
              </el-input>
          </el-form-item>
          <el-row>
              <el-col>
                  <el-form-item label="相关合同：">
                      <el-upload
                          :action="uploadUrl"
                          :headers="headers"
                          :on-success="handleAvatarSuccess"
                          :before-upload="beforeAvatarUpload"
                          list-type="picture-card"
                          limit="3"
                          :file-list="imgList"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="handleRemove">
                          <i class="el-icon-plus">+</i>
                      </el-upload>
                  </el-form-item>
              </el-col>
          </el-row>
          </el-form>
          <template #footer>
          <div class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取消</el-button>
              <el-button type="primary" @click="saveInfo()">确定</el-button>
          </div>
          </template>
      </el-dialog>

      <!-- 分成方合同图片预览 -->
      <el-dialog v-model="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
  
      <!-- 对话框--删除 -->
      <el-dialog
        v-model="centerDialogVisible"
        title="提示"
        width="500"
        align-center
      >
        <span>确定删除该分成方？</span>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="deleteUser()">确定</el-button>
          </div>
        </template>
      </el-dialog>
  
    </template>
    
    <script>
import { required, isNumber, noSpecialChar } from '@/utils/validators';
    export default {
    name:'PartnerManage',
    data() {
      return {
        formInline:{
          type:'',
          time:'',
          date:[],
          keyword:''
        },
        typeOptions:[
          {
            label:'全部',
            value:''
          },
          {
            label:'物业',
            value:1
          },
          {
            label:'互联互通技术支持',
            value:2
          },
          {
            label:'其他居间方',
            value:9
          }
        ],
        selectedRoles: [],
        rolesList:[
          {
            label:'物业',
            value:1
          },
          {
            label:'互联互通技术支持',
            value:2
          },
          {
            label:'其他居间方',
            value:9
          }
        ],
        isUpdate:false,
        dialogTitle:'添加分成方',
        dialogFormVisible:false,
        centerDialogVisible:false,
        currt_id:'', //当前操作id
        tableData:[],
        addFormRef: null,
        addRules: {
          name: [required('请输入分成方名称'), noSpecialChar('分成方名称不能包含特殊字符')],
          type: [required('请选择分成方角色')],
          username: [required('请输入账户名')],
          account: [required('请输入收款账号')],
          bankOf: [required('请输入开户行')],
          date: [required('请选择合作期限')],
          time: [required('请输入合作时长'), isNumber('合作时长只能输入数字')],
        },
        addInfo:{
          name:'',
          type:'',
          username:'',
          account:'',
          bankOf:'',
          date:[],
          time:'',
        },
        total: 0, //总条数
        currentPage: 1, //当前页
        pageSize: 10, //每页显示条数
        uploadUrl:process.env.NODE_ENV === 'development' ? '/api' +this.$store.state.platformApi+"oss/upload" : process.env.VUE_APP_API_URL + '/' + this.$store.state.platformApi+"oss/upload",
        headers: {
          'Authorization': localStorage.getItem('token')
        },
        imgList:[],
        dialogVisible:false,
        dialogImageUrl:''
      }
    },
    components: {
      
    },
    computed: {
      filteredMessage() {
        // 这里可以实现类似过滤器的转换逻辑
      }
    },
    beforeCreate(){
      
    },
    created(){
      
    },
    mounted(){
      this.getList();
    },
    methods:{
      handleAvatarSuccess(res, file) {
        // 上传成功后的处理逻辑
        this.imgList.push({
            url: res.data.url,
        });
      },
      handleRemove(file, fileList) {
        // 删除文件后的处理逻辑
        this.imgList = this.imgList.filter((item) => item.url !== file.url);
      },
      handlePictureCardPreview(file) {
        // 预览图片
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      beforeAvatarUpload(file) {
        // 上传前的处理逻辑
        // const isJPG = file.type === 'image/jpeg';
        // if (!isJPG) {
        //   this.$message.error('上传图片只能是 JPG 格式!');
        // }
        // return isJPG;
      },
      handleSizeChange (val) { //每页显示条数
          this.pageSize = val;
          this.currentPage = 1;
          this.getList();
      },
      handleCurrentChange(val) { //当前页
          this.currentPage = val;
          this.getList(); //获取列表
      },
      search(){
        //搜索
        let that = this;
        let param = {};
        param.page = 1;
        param.pageSize = this.pageSize;
        param.type = that.formInline.type;
        param.time = that.formInline.time;
        param.keyword = that.formInline.keyword;
        // console.log(that.formInline);
        if(that.formInline.date && that.formInline.date.length > 0){
          param.start = that.formInline.date[0];
          param.end = that.formInline.date[1];
        }
        that.$axios.post(that.$store.state.platformApi+"partner/page",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData = result.data.records;
            that.total = result.data.total;
          }
        })
      },
      getList(){
        //获取列表
        let that = this;
        let param = {};
        param.page = this.currentPage;
        param.pageSize = this.pageSize;
        that.$axios.post(that.$store.state.platformApi+"partner/page",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData = result.data.records;
            that.total = result.data.total;
          }
        })
      },
      saveInfo(){
        //保存
        let that = this;
        // 表单校验
        this.$refs.addFormRef.validate((valid) => {
          if (!valid) return;
          let param = {};
          if(that.isUpdate){
            //编辑
             var url = that.$store.state.platformApi+"partner/update";
          }else{
              var url = that.$store.state.platformApi+"partner/add";
          }
          param = this.addInfo;
          if(!that.addInfo.date || that.addInfo.date.length === 0){
            that.$message.error('请选择时间范围');
            return;
          }else{
            param.start = that.addInfo.date[0];
            param.end = that.addInfo.date[1];
          }
          param.contractUri = this.imgList.map(item => item.url).join(',');
          that.$axios.post(url,JSON.stringify(param)).then(result => {
            if(result.code==200){
              // 保存成功
              that.dialogFormVisible = false;
              that.$message.success('保存成功');
              that.getList();
            }
          })
        });
      },
      showAdd(index,row){
        //打开添加弹窗
          this.isUpdate = false;
          this.dialogTitle = '添加分成方';
          this.imgList = [];
          this.addInfo = Object.fromEntries(
            Object.keys(this.addInfo).map(key => [key, ''])
          );
          this.dialogFormVisible = true;
      },
      handleEdit(index,row){
        //打开编辑
        this.dialogTitle = '编辑分成方';
        this.isUpdate = true;
        this.dialogFormVisible = true;
        this.addInfo = row;
        this.addInfo.date = [this.addInfo.start, this.addInfo.end];
        if(this.addInfo.contractUri){
          this.imgList = this.addInfo.contractUri.split(',').map(url => ({ url }));
        }
      },
      deleteUser(){
        //删除
        let that = this;
        that.$axios.post(that.$store.state.platformApi+"partner/delete/"+that.currt_id).then(result => {
          // console.log(result);
          if(result.code==200){
            that.centerDialogVisible = false;
            that.getList();
          }
        })
      },
      handleDelete(index,row){
          //删除弹窗
        this.centerDialogVisible = true;
        this.currt_id = row.id;
      },
      typeFilter(value) {
        //过滤函数
        switch (value) {
          case 1:
            return '物业';
          case 2:
            return '互联互通技术支持';
          case 9:
            return '其他居间方';
          default:
            return value;
        }
      },
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .search_nav{
      width: 100%;
      height: 60px;
  }
  </style>